// import React, { useState, useRef, useEffect } from 'react';
// import { FaLifeRing, FaUserCog } from 'react-icons/fa';
// import { BsFillBellFill } from 'react-icons/bs';
// import { FaRegMessage } from 'react-icons/fa6';
// import { useNotificationContext } from '../../context/NotificationContext';
// import { useAppContext } from '../../context/AppContext';

// const HeaderRight = ({ onMobileMenuToggle }) => {
//   const {messages,notifications,shownMessageCount, shownNotificationCount, EventListener } = useNotificationContext();
//   const {logout} = useAppContext()

//   const [activeModal, setActiveModal] = useState(null);
//   const headerRef = useRef(null);
// console.log(notifications)
//   // Close modal if click outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (headerRef.current && !headerRef.current.contains(event.target)) {
//         setActiveModal(null);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const toggleModal = (modalName) => {
//     setActiveModal(prev => (prev === modalName ? null : modalName));
//   };

//   return (
//     <div ref={headerRef} className="flex items-center space-x-8">
//       {/* Mobile hamburger */}
//       <div className="md:hidden relative">
//         <button onClick={onMobileMenuToggle} className="text-2xl relative">
//           &#9776;
//           {(shownMessageCount > 0 ) && (
//             <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold rounded-full h-4 w-4 flex items-center justify-center">
//               !
//             </span>
//           )}
//         </button>
//       </div>

//       {/* Messages */}
//       <div className="relative hidden md:block">
//         <button onClick={() => toggleModal('messages')} className="relative">
//           <FaRegMessage size={26} />
//         {shownMessageCount > 0 && <span className="absolute -top-1 -right-1 bg-red-600 text-xs text-white rounded-full h-4 w-4 flex items-center justify-center">
//             {shownMessageCount}
//           </span>}
//         </button>
//         {activeModal === 'messages' && (
//           <div className="absolute right-0 mt-3 w-64 bg-white text-black rounded-lg shadow-xl z-50 p-4">
//             <h3 className="font-bold mb-2">Messages</h3>
//            {  messages.length > 0 ?
//                messages?.map(message => {
              
//                     return       <div>
//       <h3>Messages ({shownMessageCount})</h3>
//       <ul>
//         {messages.map((msg, i) => (
//           <li key={i}>{msg.content}</li>
//         ))}
//       </ul>

//       <h3>Notifications</h3>
//       <ul>
//         {notifications.map((n, i) => (
//           <li key={i}>{n.content}</li>
//         ))}
//       </ul>
//     </div>
//                 }) :
//                 <p className="text-md text-gray-600">No messages at the moment</p>
//            } 
//           </div>
//         )}
//       </div>

//       {/* Notifications */}
//       {/* Notifications */}
// <div className="relative hidden md:block">
//   <button
//     onClick={() => toggleModal('notifications')}
//     className="relative"
//   >
//     <BsFillBellFill size={26} />
//     {shownNotificationCount > 0 && (
//       <span className="absolute -top-1 -right-1 bg-red-600 text-xs text-white rounded-full h-4 w-4 flex items-center justify-center">
//         {shownNotificationCount}
//       </span>
//     )}
//   </button>

//   {activeModal === 'notifications' && (
//     <div className="absolute right-0 mt-3 w-64 bg-white text-black rounded-lg shadow-xl z-50 p-4">
//       <h3 className="font-bold mb-2">Notifications</h3>

//       {notifications.length > 0 ? (
//         <ul>
//           {notifications.map((notice) => (
//             <li
//               key={notice.id}
//               className={`text-sm p-1 rounded ${
//                 notice.unread ? 'font-bold bg-gray-100' : 'text-gray-600'
//               }`}
//             >
//               {notice.content}{' '}
//               <small className="text-xs text-gray-400">
//                 {new Date(notice.time).toLocaleTimeString()}
//               </small>
//             </li>
//           ))}
//         </ul>
//       ) : (
//         <p className="text-md text-gray-600">
//           No notifications at the moment
//         </p>
//       )}
//     </div>
//   )}
// </div>
//       {/* <div className="relative hidden md:block">
//         <button onClick={() => toggleModal('notifications')} className="relative">
//           <BsFillBellFill size={26} />
//             {shownNotificationCount > 0 &&   <span className="absolute -top-1 -right-1 bg-red-600 text-xs text-white rounded-full h-4 w-4 flex items-center justify-center">
//             {shownNotificationCount}
//           </span>}
        
//         </button>
//         {activeModal === 'notifications' && (
//           <div className="absolute right-0 mt-3 w-64 bg-white text-black rounded-lg shadow-xl z-50 p-4">
//             <h3 className="font-bold mb-2">Notifications</h3>
//             {notifications.length > 0 ?
//              notifications?.map(notice => {
//                     return   <p className="text-sm text-gray-600">{notice}</p>
//                 }):
//                 <p className="text-md text-gray-600">No notifications at the moment</p>}
//           </div>
//         )}
        
//       </div> */}

//       {/* Help */}
//       <div className="relative hidden md:block">
//         <button onClick={() => toggleModal('help')}>
//           <FaLifeRing size={26} />
//         </button>
//         {activeModal === 'help' && (
//           <div className="absolute right-0 mt-3 w-48 bg-white text-black rounded-lg shadow-xl z-50 p-4">
//             <p className="text-sm text-gray-600">Help section</p>
//           </div>
//         )}
//       </div>

//       {/* User dropdown */}
//       <div className="relative hidden md:block">
//         <button onClick={() => toggleModal('profile')}>
//           <FaUserCog size={28} />
//         </button>
//         {activeModal === 'profile' && (
//           <div className="absolute right-0 mt-3 w-48 bg-white text-black rounded-lg shadow-xl z-50 p-4">
//             <button className="block w-full text-left px-2 py-1 rounded hover:bg-gray-100">Account</button>
//             <button className="block w-full text-left px-2 py-1 rounded hover:bg-gray-100">Settings</button>
//             <button className="block w-full text-left px-2 py-1 rounded hover:bg-gray-100 text-red-600" onClick={e => logout()}>Logout</button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default HeaderRight;


// src/components/Header/HeaderRight.jsx
import React, { useState, useRef, useEffect } from "react";
import { FaLifeRing, FaUserCog } from "react-icons/fa";
import { BsFillBellFill } from "react-icons/bs";
import { FaRegMessage } from "react-icons/fa6";
import { useNotificationContext } from "../../context/NotificationContext";
import { useAppContext } from "../../context/AppContext";

const HeaderRight = ({ onMobileMenuToggle }) => {
  const {
    messages,
    notifications,
    shownMessageCount,
    shownNotificationCount,
    resetMessageBadge,
    resetNotificationBadge,
  } = useNotificationContext();

  const { logout } = useAppContext();
  const [activeModal, setActiveModal] = useState(null);
  const headerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setActiveModal(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleModal = (modalName) => {
    setActiveModal((prev) => (prev === modalName ? null : modalName));
    if (modalName === "messages") resetMessageBadge();
    if (modalName === "notifications") resetNotificationBadge();
  };

  return (
    <div ref={headerRef} className="flex items-center space-x-8">
      {/* Messages */}
      <div className="relative">
        <button onClick={() => toggleModal("messages")} className="relative">
          <FaRegMessage size={26} />
          {shownMessageCount > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-600 text-xs text-white rounded-full h-4 w-4 flex items-center justify-center">
              {shownMessageCount}
            </span>
          )}
        </button>
        {activeModal === "messages" && (
          <div className="absolute right-0 mt-3 w-64 bg-white text-black rounded-lg shadow-xl z-50 p-4">
            <h3 className="font-bold mb-2">Messages</h3>
            {messages.length > 0 ? (
              <ul>
                {messages.map((msg) => (
                  <li
                    key={msg.id || msg.time}
                    className={
                      msg.unread ? "font-bold p-1 rounded bg-gray-100" : "text-gray-600 p-1"
                    }
                  >
                    {msg.content}{" "}
                    <small className="text-xs text-gray-400">
                      {new Date(msg.time).toLocaleTimeString()}
                    </small>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-600 text-md">No messages at the moment</p>
            )}
          </div>
        )}
      </div>

      {/* Notifications */}
      <div className="relative">
        <button onClick={() => toggleModal("notifications")} className="relative">
          <BsFillBellFill size={26} />
          {shownNotificationCount > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-600 text-xs text-white rounded-full h-4 w-4 flex items-center justify-center">
              {shownNotificationCount}
            </span>
          )}
        </button>
        {activeModal === "notifications" && (
          <div className="absolute right-0 mt-3 w-64 bg-white text-black rounded-lg shadow-xl z-50 p-4">
            <h3 className="font-bold mb-2">Notifications</h3>
            {notifications.length > 0 ? (
              <ul>
                {notifications.map((n) => (
                  <li
                    key={n.id || n.time}
                    className={
                      n.unread ? "font-bold p-1 rounded bg-gray-100" : "text-gray-600 p-1"
                    }
                  >
                    {n.content}{" "}
                    <small className="text-xs text-gray-400">
                      {new Date(n.time).toLocaleTimeString()}
                    </small>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-600 text-md">No notifications at the moment</p>
            )}
          </div>
        )}
      </div>

      {/* Help */}
      <div className="relative">
        <button onClick={() => toggleModal("help")}>
          <FaLifeRing size={26} />
        </button>
        {activeModal === "help" && (
          <div className="absolute right-0 mt-3 w-48 bg-white text-black rounded-lg shadow-xl z-50 p-4">
            <p className="text-gray-600 text-sm">Help section</p>
          </div>
        )}
      </div>

      {/* User dropdown */}
      <div className="relative">
        <button onClick={() => toggleModal("profile")}>
          <FaUserCog size={28} />
        </button>
        {activeModal === "profile" && (
          <div className="absolute right-0 mt-3 w-48 bg-white text-black rounded-lg shadow-xl z-50 p-4">
            <button className="block w-full text-left px-2 py-1 rounded hover:bg-gray-100">
              Account
            </button>
            <button className="block w-full text-left px-2 py-1 rounded hover:bg-gray-100">
              Settings
            </button>
            <button
              onClick={logout}
              className="block w-full text-left px-2 py-1 rounded hover:bg-gray-100 text-red-600"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderRight;